import React from 'react';
import FormBase, { FormItemState } from '../FormBase';
import "react-datepicker/dist/react-datepicker.css";
import './FormText.css'
import { FormattedMessage } from 'react-intl';

export default function FormText(props: {
    titleId?: string,
    id?: string,
    feedBackId?: string
    state?: FormItemState
    value: string
}) {

    return (
        <FormBase titleId={props.titleId} id={props.id} feedBackId={props.feedBackId}>
            <span className="form-text">
                <FormattedMessage id={props.value} description={"form text"} defaultMessage={props.value} />
            </span>
        </FormBase>
    )
}